import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import constants from "../../../constants";
import TableDropdownAndPagination from "../../../services/TableDropdownAndPagination";
import { checkIfFileIsaDocument } from "../../../services/FileOperationGlobalFunctions";
import GlobalViewFileModal from "../../../services/GlobalViewFileModal";
import { redirectUrl, setServiceUserIdSession } from "../../../services/GlobalUrls";
import ExportButtons from "../SkeletonLoader/ExportButtons";
import TableNewPaginanation from "../../../services/TableNewPaginanation";
const ServiceUserListCandidate = (props) => {
  const [serviceUserDetails, setServiceUserDetails] = useState([]);
  const [recordLen, setRecordLen] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [dataLen, setDataLen] = useState(0);
  const [filter, setFilter] = useState("");
  const [modalOption, setModalOption] = useState(false);
  const [modalHeight, setModalHeight] = useState("500px");
  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");

  let totalPages = Math.ceil(dataLen / recordsPerPage);
  let startIndex = (currentPage - 1) * recordsPerPage;
  let endIndex = Math.min(startIndex + recordsPerPage, dataLen);

  useEffect(() => {
    const lenOfData = props.serviceUserDetailsCandidate.length;
    // console.log("lenOfData", lenOfData);
    setDataLen(lenOfData);
    totalPages = Math.ceil(lenOfData / recordsPerPage);
    startIndex = (currentPage - 1) * recordsPerPage;
    endIndex = Math.min(startIndex + recordsPerPage, lenOfData);
    setServiceUserDetails(props.serviceUserDetailsCandidate);
  }, [props.serviceUserDetailsCandidate]);

  const handleLeft = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleRight = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const visiblePages = 4;

  const renderPageNumbers = () => {
    const pageNumbers = [];
    let startPage = currentPage - Math.floor(visiblePages / 2);
    let endPage = currentPage + Math.floor(visiblePages / 2);

    if (startPage < 1) {
      startPage = 1;
      endPage = Math.min(totalPages, visiblePages);
    }

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, totalPages - visiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={i === currentPage ? "active" : ""}
          onClick={() => {
            setCurrentPage(i);
            setFilter("");
          }}
        >
          <Link to="#">{i}</Link>
        </li>
      );
    }

    return pageNumbers;
  };

  const handleDropDown = (value) => {
    setRecordLen(value);
    setRecordsPerPage(value);
    setCurrentPage(1);
  };
  const viewFileModal = (url, fileName) => {
    if (checkIfFileIsaDocument(url)) {
      setModalHeight("500px");
      setFileUrl(url);
      setFileName(fileName);
    } else {
      redirectUrl(url);
    }
  };

  const callModal = () => {
    document.getElementById("loader").style.display = "block";
    setModalOption(true);
  };
  const loaderEnd = () => {
    document.getElementById("loader").style.display = "none";
    setModalHeight("auto");
  };

  const closeFileModal = () => {
    setModalOption(false);
    setFileUrl("");
  };

  const onPageChange = (page, newPageSize = recordsPerPage) => {
  if (newPageSize !== recordsPerPage) {
    setRecordsPerPage(newPageSize);
    setRecordLen(newPageSize);
    setCurrentPage(1);
  } else {
    setCurrentPage(page);
  }
};

const prepareServiceUserExportData = (data) => {
  if (!data || data.length === 0) return [];

  return data.map((user, index) => ({
    "Sr.No.": index + 1,
    "Date & Time":
      user.domiciliary_care_client_service_user_created_date || "-",
    "Service User Name": user.service_user_name || "-",
    Phone:
      user.domiciliary_care_client_service_user_mobile_number || "-",
    Email:
      user.domiciliary_care_client_service_user_email || "-",
  }));
};

const exportData = React.useMemo(() => {
  return prepareServiceUserExportData(serviceUserDetails);
}, [serviceUserDetails]);



  return (
    <React.Fragment>
      <div className="m-b30 wrapper">
        {/* Search Start */}
{/* Search Start */}
<div className="container">
  <div className="row align-items-center mb-3">

    {/* LEFT – Export Buttons */}
    <div className="col-sm-6 d-flex align-items-center">
      {/* <ExportButtons
        data={exportData}
        fileName="Service_Users_List"
        buttons={true}
      /> */}
    </div>

    {/* RIGHT – Search */}
    <div className="col-sm-6 d-flex justify-content-end">
      <input
        type="text"
        name="search"
        className="form-control"
        placeholder="Search here"
        style={{ height: "40px", width: "200px" }}
        id="myInput"
      />
    </div>

  </div>
</div>
{/* Search End */}

        {/* Search End */}
        <div className="courses-section">
         <table className="courses-table">
            <thead className="text-white">
            <tr>
              <th scope="col">Date & Time</th>
              <th scope="col">Service User Name</th>
              <th scope="col">Phone</th>
              <th scope="col">Email</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody id="myTable">
            {serviceUserDetails &&
              serviceUserDetails.length > 0 &&
              serviceUserDetails
                ?.slice(startIndex, endIndex)
                .map((service_user_details, i) => (
                  <tr key={i}>
                    <td className="col-4" scope="row">
                      {
                        service_user_details.domiciliary_care_client_service_user_created_date
                      }
                    </td>
                    <td scope="row">
                      {service_user_details.service_user_name}
                    </td>
                    <td scope="row">
                      {
                        service_user_details.domiciliary_care_client_service_user_mobile_number
                      }
                    </td>
                    <td scope="row">
                      {
                        service_user_details.domiciliary_care_client_service_user_email
                      }
                    </td>
                    <td scope="col">
                      {service_user_details.domiciliary_care_client_id ? (
                        <a
                          onClick={() => setServiceUserIdSession(service_user_details.domiciliary_care_client_id)}
                          className={"btn btn-dark btn-sm text-white"}
                        >
                          <i className={"fa fa-eye"}></i>
                        </a>
                      ) : (
                        " - "
                      )}
                    </td>
                    {/*<td  className="col-1 text-center" scope="col"> <Link to={"/create-timesheet/"+service_user_details.cnd_timesheet_id}><i className="fa fa-pencil"></i></Link></td>*/}
                  </tr>
                ))}
            {serviceUserDetails.length == 0 && (
              <tr>
                <td colSpan="100" className="text-center">No Details Founds.</td>
              </tr>
            )}
          </tbody>
        </table>
        </div>
       {serviceUserDetails &&  (
  <TableNewPaginanation
    totalItems={dataLen}
    pageSize={recordsPerPage}
    currentPage={currentPage}
    onPageChange={onPageChange}
    isDropdown={true}
    isPaggination={true}
  />
        )}
      </div>
      <GlobalViewFileModal
        modalOption={modalOption}
        closeFileModal={closeFileModal}
        fileUrl={fileUrl}
        // fileName={fileName}
        loaderEnd={loaderEnd}
        modalHeight={modalHeight}
        callModal={callModal}
        title={"Daily Logs - Uploaded Documents"}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    serviceUserDetailsCandidate:
      state.serviceUserDetailsCandidate.serviceUserDetailsCandidate,
  };
};

export default connect(mapStateToProps)(ServiceUserListCandidate);
